<template lang='pug'>
EventToProp(
  :key='uid'
  v-slot='{ prop, timestamp, updateProp }'
)
  Dialog(
    :key='timestamp'
    v-if='prop'
  )
    v-row
      v-spacer
      v-col(
        cols='12'
        md='6'
        lg='4'
      )
        Auth
      v-spacer
  slot(
    :isAnonymous='isAnonymous'
    :updateProp='updateProp'
  )
    v-btn.mx-2.hidden-xs-only(
      v-if='isAnonymous'
      @click='updateProp(true)'
      text
    )
      | Sign up - It's free!
    v-btn.mx-2(
      icon
      outlined
      @click='updateProp(true)'
    )
      v-icon {{ icon }}
</template>

<script>
import { at, compact, cond, get, head, identity, invokeArgs, isBoolean, pipe, stubTrue, toLower, wrap } from 'lodash/fp';

import Auth from './Auth.vue';
import Dialog from './Dialog.vue';
import EventToProp from './EventToProp.vue';

import {
  app,
} from '../functions/initializeApp';

import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth';

const auth = getAuth(app);

const mounted = function ()
{
  this.unsubscribe = onAuthStateChanged
  (
    auth,
    currentUser => this.currentUser = currentUser
  );
};

const destroyed = function ()
{
  this.unsubscribe();
};

const icon = function ()
{
  return cond
  ([
    [get('isAnonymous'), wrap(null)('mdi-incognito')],
    [get('initial'), wrap(null)(`mdi-alpha-${ this.initial }`)],
    [stubTrue, wrap(null)('mdi-account')],
  ])
  (this);
};

const isAnonymous = function ()
{
  return pipe
  ([
    get('currentUser.isAnonymous'),
    cond
    ([
      [isBoolean, identity],
      [stubTrue, stubTrue],
    ]),
  ])
  (this);
};

const initial = function ()
{
  return pipe
  ([
    get('currentUser'),
    at(['displayName', 'email']),
    compact,
    head,
    invokeArgs('charAt')([0]),
    toLower,
  ])
  (this);
};

const uid = function ()
{
  return get
  ('currentUser.uid')
  (this);
};

export default
{
  components:
  {
    Auth,
    Dialog,
    EventToProp,
  },
  computed:
  {
    icon,
    initial,
    isAnonymous,
    uid,
  },
  data()
  {
    return {
      currentUser: null,
      unsubscribe: null,
    };
  },
  destroyed,
  mounted,
};
</script>